import styles from "./index.module.scss"

// todo: corrigir erros com logos importadas do legacy
// import visaLogo from "../../../../../assets/img/credit-card/cc-visa.svg"
import mastercardLogo from "../../../../../assets/img/credit-card/cc-mastercard.svg"
import maestroLogo from "../../../../../assets/img/credit-card/cc-maestro.svg"
// import dinnersClubLogo from "../../../../../assets/img/credit-card/cc-diners-club.svg"
// import discoverLogo from "../../../../../assets/img/credit-card/cc-discover.svg"
// import jcbLogo from "../../../../../assets/img/credit-card/cc-jcb.svg"
import amexLogo from "../../../../../assets/img/credit-card/cc-amex.svg"
// import hiperCardLogo from "../../../../../assets/img/credit-card/cc-hipercard.svg"
// import unionPayLogo from "../../../../../assets/img/credit-card/cc-unionpay.svg"
// import eloLogo from "../../../../../assets/img/credit-card/cc-elo.svg"
import creditCardIcon from "../../../../../assets/img/credit-card/cc.svg"
import creditCardType from "credit-card-type"

export default function CreditCardDisplay({
  cCreditCardNumber = "",
  cDueMonth = "",
  cDueYear = "",
}) {
  const CREDITCARD_TYPE_LOGO = {
    // visa: visaLogo,
    mastercard: mastercardLogo,
    "american-express": amexLogo,
    // "diners-club": dinnersClubLogo,
    // discover: discoverLogo,
    // jcb: jcbLogo,
    // unionpay: unionPayLogo,
    maestro: maestroLogo,
    mir: creditCardIcon,
    // elo: eloLogo,
    hiper: creditCardIcon,
    // hipercard: hiperCardLogo,
  }

  const formatCreditCardNumber = () => {
    if (cCreditCardNumber.length >= 4) {
      return "**** " + cCreditCardNumber.substr(cCreditCardNumber.length - 4)
    }
    return "N/A"
  }

  const formatCreditCardDueDate = () => {
    let cDueDate = ""
    cDueDate = cDueMonth.length > 0 ? `${cDueMonth}` : "N/A"
    cDueDate += cDueYear.length > 0 ? ` / ${cDueYear}` : " / N/A"

    return cDueDate
  }

  const getCreditCardBrand = () => {
    const creditCardPrefix = cCreditCardNumber.substring(0, 6)
    const cardType = creditCardType(creditCardPrefix)

    if (cardType.length === 1) {
      return (
        <img
          className={styles.creditCardLogo}
          src={CREDITCARD_TYPE_LOGO[cardType[0].type]}
          alt={cardType[0].niceType + " logo"}
        />
      )
    }

    return <i className={`icon ${styles.iconCreditCard}`} />
  }

  return (
    <>
      {getCreditCardBrand()}
      <span>{`${formatCreditCardNumber()} (${formatCreditCardDueDate()})`}</span>
    </>
  )
}
